<template>
  <a
    class="train-category"
    :class="{'selectable': selectable, 'selected': internalSelected}"
    :style="itemStyle"
    :title="category.title"
    @click="onClick"
  >{{ category.display_name }}</a>
</template>

<script>
export default {
  name: 'TrainCategory',
  props: {
    category: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  watch: {
    selected() {
      this.internalSelected = this.selected;
    },
  },
  data() {
    return {
      itemStyle: {
        backgroundColor: this.category.color,
      },
      internalSelected: this.selectable && this.selected,
    };
  },
  methods: {
    onClick() {
      if (this.selectable) {
        this.internalSelected = !this.internalSelected;
        this.$emit('selectionChanged', this.internalSelected);
      }
    },
  },
};
</script>

<style scoped>
.train-category {
  color: #fff;
  padding: 4px 15px;
  font-weight: 600;
  cursor: default;
}

.train-category.selected {
  border-bottom: 2px solid #fff;
}

.train-category.selectable {
  cursor: pointer;
}

.train-category.selectable:not(.selected) {
  filter: opacity(50%);
}
</style>
